var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-light",attrs:{"type":"button"}},[_c('i',{staticClass:"icon-calendar5"})])}]

export { render, staticRenderFns }